import {NgModule} from '@angular/core';
import {SharedModule} from '../../shared/shared.module';
import {FirmwareTableComponent} from './table/firmware-table.component';
import {FirmwareCreateComponent} from './create/firmware-create.component';
import {FirmwareEditComponent} from './edit/firmware-edit.component';

@NgModule({
  declarations: [
    FirmwareTableComponent,
    FirmwareCreateComponent,
    FirmwareEditComponent
  ],
  imports: [SharedModule],
  exports: [
    FirmwareTableComponent,
    FirmwareCreateComponent,
    FirmwareEditComponent
  ]
})
export class FirmwareModule {}
